import React from 'react';
import '../styles/ElementChart.css';

function ElementChart() {
  return (
    <div className="element-chart">
      <h3>ELEMENT CHART</h3>
      <img src="/Elemental_chart.webp" alt="Skylanders Element Relationships" />
    </div>
  );
}

export default ElementChart;
